<template>
  <div class="asset-slider boxshadow-soft">
    <div class="asset-slider__labels">
      <span>{{ $t("global.less") }}</span>
      <span>{{ $t("global.more") }}</span>
    </div>
    <div class="slider-wrap">
      <input
        type="range"
        min="1"
        v-bind:max="maxRange"
        class="slider"
        v-model="assetsState"
        ref="slider"
      />
      <div class="asset-slider__dots">
        <span class="asset-slider__dot" v-for="n in assetRanges" v-bind:key="n"></span>
      </div>
    </div>
    <div class="asset-slider__valuewrap">
      <span class="asset-slider__value" v-html="rangeValueText"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      assetRanges: this.$t("depotfinder.assets.asset-ranges"),
      rangeValue: ""
    };
  },

  computed: {
    rangeValueText() {
      return this.assetRanges[this.assetsState];
    },
    maxRange() {
      return Object.keys(this.assetRanges).length;
    },
    assetsState: {
      get() {
        return this.$store.getters.getAssetsState;
      },
      set(value) {
        this.$store.dispatch("updateAssetsState", value);
      }
    }
  },

  mounted() {
    // Initialize range value if not yet set
    this.assetsState = this.assetsState || 2;
  }
};
</script>
